/* eslint-disable no-unused-vars */
// // #region Dependencias
// import dayjs from "dayjs";
// import { getInternalAnalyticsGA } from "store/slicers/analyticsSlice";
// import { finishLoading, startLoading } from "store/slicers/uiSlice";
// import { fetchWithToken } from "utils/fetch";
// import { responseMessageHandler } from "utils/responseMessageHandler";
// // #endregion

import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore'
import { connectFunctionsEmulator, httpsCallable } from 'firebase/functions'
import { db, functions } from 'services/firebase'
import {
  getAnalyticsActual,
  getClientesRecientes,
  getGlobalAnalytics,
  getPageAnalytics
} from 'store/slices/analyticsSlice'
import { finishLoading, startLoading } from 'store/slices/uiSlice'
import { responseMessageHandler } from 'utils/responseMessageHandler'

// /**
//  * Thunk que obtiene el token de acceso de Google Analytics.
//  */
// export const getTokenRequestGA = () => async () => {
//   window.client.requestAccessToken();
// };

// /**
//  * Thunk que realiza una petición al servicio de Google Analytics para
//  * obtener las estadisticas internas.
//  * @param {Object} filtros - Filtros para la consulta de estadísticas.
//  * @param {string} filtros.fechaInicio - Fecha de inicio de la consulta en formato unix.
//  * @param {string} filtros.fechaFin - Fecha de fin de la consulta en formato unix.
//  * @param {Array} usuariosAnalytics - Arreglo de usuarios a filtrar en la consulta.
//  * @returns {Function} Función que envía las acciones asíncronas al store de Redux.
//  */
// export const getInternalAnalyticsRequestGA =
//   (filtros, usuariosAnalytics) => async (dispatch, getState) => {
//     const { fechaInicio, fechaFin } = filtros;

//     dispatch(startLoading());

//     const { token } = getState().analytics;
//     if (!token) return dispatch(finishLoading());

//     const estadisticasBody = {
//       dimensions: [
//         {
//           name: "customUser:usuario_id",
//         },
//         {
//           name: "customUser:usuario_nombre",
//         },
//         {
//           name: "customUser:usuario_rol",
//         },
//         {
//           name: "customEvent:modulo",
//         },
//         {
//           name: "city",
//         },
//         {
//           name: "month",
//         },
//         {
//           name: "region",
//         },
//       ],
//       metrics: [
//         {
//           name: "sessions",
//         },
//         {
//           name: "averageSessionDuration",
//         },
//         {
//           name: "userEngagementDuration",
//         },
//       ],
//       dateRanges: [
//         {
//           startDate: dayjs(fechaInicio).format("YYYY-MM-DD"),
//           endDate: dayjs(fechaFin).format("YYYY-MM-DD"),
//         },
//       ],
//     };

//     // Si hay usuario, añadir su respectivo filtro
//     if (usuariosAnalytics.length > 0) {
//       estadisticasBody.dimensionFilter = {
//         filter: {
//           fieldName: "customUser:usuario_id",
//           inListFilter: {
//             values: usuariosAnalytics,
//             caseSensitive: false,
//           },
//         },
//       };
//     }

//     /**
//      * Realiza una petición {@link fetchWithToken} de Analytics de Google con el token y el cuerpo de la solicitud.
//      */
//     fetchWithToken(token, estadisticasBody)
//       .then((res) => res.json())
//       .then((datos) => {
//         dispatch(getInternalAnalyticsGA(datos));
//       })
//       .catch((err) => responseMessageHandler(err, dispatch))
//       .finally(() => dispatch(finishLoading()));
//   };

export const getGlobalAnalyticsRequest = () => async (dispatch) => {
  dispatch(startLoading())

  // connectFunctionsEmulator(functions, "localhost", 5001); // dev
  const getAnalytics = httpsCallable(functions, 'getGlobalAnalytics')

  getAnalytics()
    .then(({ data }) => {
      dispatch(getGlobalAnalytics(data.googleAnalyticsData.reports))
    })
    .catch((err) => responseMessageHandler(err, dispatch))
    .finally(() => dispatch(finishLoading()))
}

export const getPageAnalyticsRequest = () => async (dispatch, getState) => {
  dispatch(startLoading())

  const { paginaSeleccionada } = getState().pages

  // connectFunctionsEmulator(functions, "localhost", 5001); // dev
  const getAnalytics = httpsCallable(functions, 'getPageAnalytics')

  getAnalytics({ paginaId: paginaSeleccionada.id })
    .then(({ data }) => {
      dispatch(getPageAnalytics(data.googleAnalyticsData.reports))
    })
    .catch((err) => responseMessageHandler(err, dispatch))
    .finally(() => dispatch(finishLoading()))
}

export const getRecentClientsRequest = () => async (dispatch, getState) => {
  dispatch(startLoading())

  // Obtener pagina seleccionada actualmente
  const { paginaSeleccionada } = getState().pages

  const q = query(
    collection(db, 'clientes'),
    where('paginaId', '==', paginaSeleccionada.id),
    orderBy('fecha', 'desc'),
    limit(5)
  )

  getDocs(q)
    .then((documents) => {
      const clientes = []
      documents.forEach((doc) => {
        const clientesData = doc.data()
        clientes.push({ ...clientesData, fecha: clientesData.fecha.toDate().toString() })
      })
      dispatch(getClientesRecientes(clientes))
    })
    .catch((err) => responseMessageHandler(err, dispatch))
    .finally(() => dispatch(finishLoading()))
}
